const { throttle } = require('throttle-debounce');

if (window.Groupon.Widgets == null) {
  window.Groupon.Widgets = {};
}

module.exports = Groupon.Widgets.BackToTopButton = class {
  constructor() {
    this.requestTick = this.requestTick.bind(this);
    this.showOrHide = this.showOrHide.bind(this);
    this.bindEvents = this.bindEvents.bind(this);
    if (!(this.back2top = document.getElementById('ls-back-to-top'))) {
      return;
    }
    // show when the header is not visible anymore
    this.offset =
      document.querySelector('.header-v2 header').offsetHeight * 1.5;
    this.visible = false;
    this.bindEvents();
  }

  requestTick() {
    return window.requestAnimationFrame(this.showOrHide);
  }

  showOrHide() {
    // y scroll position: modern browsers, IE9+
    const y = window.scrollY || window.pageYOffset;
    const threshold = y > this.offset;

    if (threshold && !this.visible) {
      // set z-index before opacity change so we see transition
      this.back2top.classList.add('ls-back-to-top-visible');
      this.back2top.setAttribute('aria-hidden', 'false');
      this.visible = true;
    } else if (this.visible && !threshold) {
      this.back2top.setAttribute('aria-hidden', 'true');
      this.back2top.classList.remove('ls-back-to-top-visible');
      this.visible = false;
    }
  }

  bindEvents() {
    window.addEventListener('scroll', throttle(1000, this.requestTick), {
      passive: true,
    });

    return this.back2top.addEventListener(
      'click',
      () => {
        this.back2top.addEventListener(
          'transitionend',
          () => {
            return this.back2top.classList.remove('ls-back-to-top-visible');
          },
          { once: true, passive: true }
        );

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });

        return this.back2top.setAttribute('aria-hidden', 'true');
      },

      { passive: true }
    );
  }
};
